export const isAPDFFile = (file) => {
  if (typeof file === "string") {
    return file.endsWith(".pdf");
  }
  return file.name.endsWith(".pdf") || file.type === "application/pdf";
};
